/* RTD PDP - retire the 7-day frequency.
 *
 * The 7-day cadence was churning, so it is no longer offered here: the shortest
 * option on this PDP is now 10 days, which also matches the greens builder's
 * 1-pack default. The plan itself stays alive in Loop, so existing 7-day
 * subscribers keep their contracts untouched - this only takes it off the picker
 * for new purchases.
 *
 * Loop renders its widget client-side and builds one select per variant, so this
 * watches for them rather than running once. Options are matched on the interval
 * parsed from the label rather than on a plan id, so a re-created 7-day plan
 * cannot quietly reappear.
 *
 * Checked against Loop before relying on it: removing an option and firing change
 * does NOT make Loop re-render the widget, and its own handler moves the hidden
 * selling_plan input. So there is no need to write that input directly, which
 * would risk desyncing it from the displayed price.
 */
(function () {
  var HANDLE = "be-amazing-daily-greens-drink-in-a-can-ready-to-drink";
  var HIDE_DAYS = 7;
  var SEL = "select.loop-selling-plan-selector";

  /* This asset is loaded from the rtd-pdp template, but templates get reassigned.
     Silently rewriting some other product's frequencies would be far worse than
     doing nothing, so the product is checked rather than assumed. */
  function onProduct() {
    return location.pathname.indexOf("/products/" + HANDLE) !== -1;
  }

  function daysOf(opt) {
    var m = String(opt.textContent || "").match(/every\s+(\d+)\s*days?/i);
    return m ? parseInt(m[1], 10) : null;
  }

  function fix() {
    var sels = document.querySelectorAll(SEL);
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i], doomed = [], wasSelected = false;
      for (var j = 0; j < sel.options.length; j++) {
        if (daysOf(sel.options[j]) !== HIDE_DAYS) continue;
        doomed.push(sel.options[j]);
        if (j === sel.selectedIndex) wasSelected = true;
      }
      if (!doomed.length) continue;
      for (var k = 0; k < doomed.length; k++) doomed[k].remove();

      /* Loop lists plans shortest-first, so with 7 gone index 0 IS 10 days. Only
         move the shopper when they were sitting on the option just removed -
         otherwise a deliberate 14 or 21 day pick would be snapped back to 10. */
      if (wasSelected && sel.options.length) {
        sel.selectedIndex = 0;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  function boot() {
    if (!onProduct()) return;
    fix();
    /* Loop mounts late and adds a block per variant, so one pass is not enough.
       fix() is idempotent - a second pass finds nothing to remove - so feeding it
       its own mutations settles rather than looping. */
    new MutationObserver(fix).observe(document.documentElement,
      { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();